import React, { useState } from "react";
import { InputMask } from "primereact/inputmask";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { Message } from "primereact/message";
import axios from "axios";
import { ProgressBar } from 'primereact/progressbar';
export default function InputCEP(props) {
  const [cep, setCep] = useState(props.value || "");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = React.useRef(null);


  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, ""); // Apenas números
    setCep(e.target.value); // Mantém a formatação

   

    if (props.onChange) {
      props.onChange({
        ...e,
        target: { 
          ...e.target, 
          name : props.name,
          value: e.target.value },
      });
    }
  };

  const getDataEndereco = async (cep) => {
    setLoading(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      if (response.status === 200 && !response.data.erro) {
        if(props.setDataCep){
            props.setDataCep(response.data);
        }
        
        setError(false);
      } else {
        setError(true);
        if(props.setDataCep){
            props.setDataCep(null);
        }
        toast.current.show({
          severity: "error",
          summary: "CEP inválido",
          detail: "Não foi possível encontrar o endereço.",
          life: 3500,
        });
      }
    } catch (err) {
      setError(true);
      toast.current.show({
        severity: "error",
        summary: "Erro",
        detail: "Falha ao buscar os dados do CEP.",
        life: 3500,
      });
      if(props.setDataCep){
        props.setDataCep([]);
    }
    }
    setTimeout(() => {
        setLoading(false);
    }, 500);
  };

  return (
    <div >
      <InputMask
        mask="99999-999"
        value={cep}
        onChange={handleChange}
        onKeyUp={(e)=>{
      
          if(e.keyCode == 13){
            getDataEndereco(cep);
          }
        }}
        onBlur={(e) => {
            if (cep.length >=8) {
                
            }
        }}
        placeholder="Digite o CEP"
        className={`p-inputtext w-full mt-2 ${error ? "p-invalid" : ""}`}
      />
      {loading && <ProgressBar
                mode="indeterminate" 
                style={{ height: '3px',marginTop :'2px', zIndex :'9999', }} 
                className="w-full"                 
                 />}
     
      <Toast ref={toast} />
    </div>
  );
}
